const WORK_WITH_STRING = {

  methods: {

    /**
         * Method for creating short string
         *
         * @param {String} string
         * @param {Number} shortLength | max length string
         */
    parseString (string, shortLength) {
      var shortString = '';
      var parseString = string.split(' ');
      var stringLength = parseString.length;

      if (stringLength > shortLength) {
        for (let i = 0; i < shortLength; i++) {
          shortString += parseString[i] + ' ';
        }
        shortString += '...';
      }

      return shortString;
    },

  },

};

export default WORK_WITH_STRING;
